import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { TaskProvider } from './context/TaskContext';
import { NoteProvider } from './context/NoteContext';
import { DashboardProvider } from './context/DashboardContext';
import { ToastProvider } from './hooks/use-toast';
import { Toaster } from './components/ui/toaster';
import LoginScreen from './screens/LoginScreen';
import HomeScreen from './screens/HomeScreen';
import DashboardScreen from './screens/DashboardScreen';
import TaskListScreen from './screens/TaskListScreen';
import NotesScreen from './screens/NotesScreen';
import NoteEditScreen from './screens/NoteEditScreen';
import SharedNoteScreen from './screens/SharedNoteScreen';
import CalendarScreenV2 from './screens/CalendarScreenV2';
import SketchScreen from './screens/SketchScreen';
import PrivateRoute from './components/PrivateRoute';
import NoteEditScreenV2 from './screens/NoteEditScreenV2';
import PlannerScreen from './screens/PlannerScreen';
import { DesignSystemShowcase } from './design-system';
import * as serviceWorker from './utils/serviceWorker';
import CalendarScreenV3 from './screens/CalendarScreenV3';

function App() {
  useEffect(() => {
    // Register service worker for protected asset handling
    serviceWorker.register();
  }, []);

  return (
    <Router>
      <AuthProvider>
        <TaskProvider>
          <NoteProvider>
            <DashboardProvider>
              <ToastProvider>
                <div className="min-h-screen bg-background">
                  <Routes>
                    {/* Public routes */}
                    <Route path="/login" element={<LoginScreen />} />
                    <Route path="/notes/new" element={<NoteEditScreen />} />
                    <Route path="/view-note/:noteId" element={<SharedNoteScreen />} />
                    <Route path="/notes/:id" element={<NoteEditScreenV2 />} />
                    <Route path="/n/:id" element={<NoteEditScreenV2 />} />
                    <Route path="/notes/:id/edit" element={<NoteEditScreenV2 />} />
                    <Route path="/n/:id/edit" element={<NoteEditScreenV2 />} />
                    
                    {/* Design System Showcase - Public route for easy access */}
                    <Route path="/design-system" element={<DesignSystemShowcase />} />
                    
                    {/* Sketch editor routes (public and private) */}
                    <Route path="/sketch" element={<SketchScreen />} />
                    <Route path="/sketch/new" element={<SketchScreen />} />
                    <Route path="/sketch/:sketchId" element={<SketchScreen />} />
                    <Route path="/s/:sketchId" element={<SketchScreen />} />
                    <Route path="/view-sketch/:sketchId" element={<SketchScreen viewOnly={true} isDarkMode={false} />} />
                    
                    {/* Protected routes */}
                    <Route path="/" element={
                      <PrivateRoute>
                        <HomeScreen />
                      </PrivateRoute>
                    } />
                    <Route path="/dashboard" element={
                      <PrivateRoute>
                        <DashboardScreen />
                      </PrivateRoute>
                    } />
                    <Route path="/tasks" element={
                      <PrivateRoute>
                        <TaskListScreen />
                      </PrivateRoute>
                    } />
                    <Route path="/calendar" element={
                      <PrivateRoute>
                        <CalendarScreenV3 />
                      </PrivateRoute>
                    } />
                    <Route path="/calendarv2" element={
                      <PrivateRoute>
                        <CalendarScreenV3 />
                      </PrivateRoute>
                    } />
                    <Route path="/planner" element={
                      <PrivateRoute>
                        <PlannerScreen />
                      </PrivateRoute>
                    } />
                    <Route path="/notes" element={
                      <PrivateRoute>
                        <NotesScreen />
                      </PrivateRoute>
                    } />
                    
                    {/* Redirect any unknown routes to home */}
                    <Route path="*" element={<Navigate to="/" />} />
                  </Routes>
                  <Toaster />
                </div>
              </ToastProvider>
            </DashboardProvider>
          </NoteProvider>
        </TaskProvider>
      </AuthProvider>
    </Router>
  );
}

export default App; 